import React, { useState } from 'react';
import Otp from '../../modal/Otp';
import { kitchenService } from '../../services';
import { toast } from 'react-toastify';

export interface Form2Data {
  mobileNumber: string;
  otp: string;
  token: string;
}

interface Form2Props {
  onNext: (data: Form2Data) => void;
  initialData?: Form2Data;
  mobileNumber: string;
  autoFillOtp?: string;
}

const Form2: React.FC<Form2Props> = ({ onNext, initialData, mobileNumber, autoFillOtp }) => {
  const [verifying, setVerifying] = useState(false);

  const handleVerifyOtp = async (otp: string) => {
    if (otp.length !== 6) {
      toast.error('Please enter a valid 6-digit OTP');
      return;
    }

    setVerifying(true);
    try {
      const response: any = await kitchenService.verifyOtp(mobileNumber, otp);
      
      if (response.status && response.data?.token) {
        const token = response.data.token;
        
        // Store token in localStorage
        localStorage.setItem('kitchenAuthToken', token);
        localStorage.setItem('verifiedPhoneNumber', mobileNumber);
        
        toast.success('OTP verified successfully!');
        
        // Move to next step (registration forms)
        onNext({ mobileNumber, otp, token });
      } else {
        toast.error('Failed to receive authentication token');
      }
    } catch (err: any) {
      toast.error(err.message || 'Failed to verify OTP');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div>
      <Otp 
        isOpen={true}
        onClose={() => {}} // Prevent closing during registration
        mobileNumber={mobileNumber}
        onVerify={handleVerifyOtp}
        autoFillOtp={autoFillOtp}
      />
    </div>
  );
};

export default Form2;
